<template>
    <div class="currency--container">
        <p>Currency: </p>
        <ul v-for="currency in currencies" @change="updateCurrency($event.target.value)">
            <li v-for="option in currency.options" :value="option">{{ option }}</li>
        </ul>    
        <!-- <select class="dropdown" v-for="currency in currencies" @change="updateCurrency($event.target.value)">
            <option v-for="option in currency.options" :value="option">{{ option }}</option>
        </select> -->
    </div>    
</template>

<script>
const currencies = [
    {
        options: ["USD","SGD","EUR","KRW","PHP"]
    }
]

export default {
    name: 'dropdown',
    components: {
        // 'app-description': Description
    },
    data: function() {
        return {
            // selectedCurrency: "USD",
            currencies           
        }
    },
    props: {
    },   
    methods: {
        updateCurrency: function(currency) {
            this.$emit('updateCurrency', currency);
        }
    },
    created: function() {
    }

}
</script>

<style lang="scss">
.dropdown {
  text-transform: uppercase;
  border: 1px solid #EFEFEF;
  border-radius: 4px;
  color: #B5B5B5;
  padding: 8px;
  font-size: 0.8rem;
  background: #FFFFFF;
  box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.1);
  cursor: pointer;

    &--container {
        max-width: 540px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-end;

        p {
            color: #AABBC7;
            margin: 0;            
        }        
    }


  &:hover {
    box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.25);
    // color: #  
  }

  a {
    text-decoration: none;
    color: #000000;

    &:visited {
      color: #000000;
    }    
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Currency.vue